import { h, JSX } from 'preact'
import { memo } from 'preact/compat'
import { BlockType, TBlock } from '@gsc/types'
import { BlockMapping } from './interfaces'
import { useBlockTreeMapping } from './useBlockTreeMapping'

interface Props<T extends BlockType> {
  root: TBlock<T>
  mapping?: BlockMapping
}

const renderBlock = <T extends BlockType>(block: TBlock<T>, mapping: Partial<BlockMapping>): JSX.Element => {
  const { type, id } = block
  const C = mapping[type]
  if (!C) {
    throw new Error(`Tried to render the '${type}' block, but it's not specified in the mapping.`)
  }
  const props = { ...block, key: id }
  const children = 'children' in block ? (block.children ?? []).map(child => renderBlock(child, mapping)) : null

  return h(C, props, children)
}

export const BlockTree = memo(<T extends BlockType>({ root, mapping }: Props<T>): JSX.Element => {
  const defaultMapping = useBlockTreeMapping()
  return renderBlock(root, mapping || defaultMapping)
})
